import { render, staticRenderFns } from "./ConfigCabinets.vue?vue&type=template&id=ad3548f8&scoped=true"
import script from "./ConfigCabinets.vue?vue&type=script&lang=ts"
export * from "./ConfigCabinets.vue?vue&type=script&lang=ts"
import style0 from "./ConfigCabinets.vue?vue&type=style&index=0&id=ad3548f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3548f8",
  null
  
)

export default component.exports